<template>
  <div>
    <div>
      <b-card
        no-body
      >
        <div>
          <b-row>
            <b-col
              cols="6"
              md="3"
              class="ml-2 mt-2"
            >
              <b-form-group
                label="Waybill Number"
                label-for="v-ref-no"
              >
                <b-form-input
                  id="v-ref-no"
                  v-model="filters['waybill_number']"
                  placeholder="Search"
                />
              </b-form-group>
            </b-col>
            <b-col
              class="mr-2 mt-3 d-flex justify-content-end"
            >
              <ReportTableButtons
                :items="rows"
                :json_fieldz="json_fields"
                :name="`Invoice Orders - Page ${page}.xls`"
                :bulkname="`Invoice Orders.xls`"
                :fetch="fetchWaybillForMerchantNoPagination"
                :show-refresh-button="false"
              />
            </b-col>
          </b-row>
          <!-- table -->
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              :fields="fields"
              :items="rows"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              hover
              responsive
              striped
              show-empty
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.value)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      class="font-weight-bolder ml-1 text-primary"
                      @click="onClickViewOrder(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(destination_warehouse.name)="data">
                {{ data.value || '---' }}
              </template>
              <template #cell(customer_name)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bold">
                      {{ data.value }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant_business)="data">
                <span>{{ data.item.merchant_business || '---' }}</span>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ data.value }}
                    </div>
                    <div class="font-small-2">
                      <div><b>Primary number: </b>{{ data.item.customer_phone }}</div>
                    </div>
                    <div
                      v-if="data.item.customer_secondary_phone !== null"
                      class="font-small-2"
                    >
                      <div><b>Second number: </b>{{ data.item.customer_secondary_phone }}</div>
                    </div>
                    <div class="font-small-2">
                      {{ data.item.customer_address }}
                    </div>
                  </div>
                </div>
              </template>

              <template #cell(cod)="data">
                {{ __numberWithCommas(data.item.cod, true) }}
              </template>

              <template #cell(collected_cod)="data">
                {{ __numberWithCommas(data.item.collected_cod, true) }}
              </template>

              <template #cell(delivery_charge)="data">
                {{ __numberWithCommas(data.item.delivery_charge, true) }}
              </template>

              <template #cell(balance)="data">
                {{ __numberWithCommas(data.item.delivery_charge - data.item.collected_cod, true) }}
              </template>
              <template #cell(weight)="data">
                {{ (data.value).toLocaleString() }}
              </template>

              <template #cell(description)="data">
                <div class="d-flex align-items-center width-190 font-weight-bold">
                  {{ data.value || '--' }}
                </div>
              </template>

              <template #cell(status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row
                cols="12"
              >
                <b-col
                  class="d-flex align-items-center justify-content-sm-start"
                  md="3"
                >
                  <label class="width-75">Per page</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block width-100"
                  />
                </b-col>
                <!-- Pagination -->
                <b-col
                  class="d-flex align-items-center justify-content-sm-end"
                  md="9"
                >
                  <span class="text-muted pagination-text mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                  <b-pagination
                    v-model="page"
                    :per-page="perPage"
                    :total-rows="(meta.total)? meta.total : 0"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>

              </b-row>
            </div>
          </b-overlay>
        </div>
      </b-card>
    </div>
    <view-order-modal ref="viewOrderModal" />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  VBTooltip,
  BAvatar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import ViewOrderModal from '@/components/AllOrders/ViewOrderModal.vue'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store/index'

const FinanceRepository = RepositoryFactory.get('finance')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
    vSelect,
    OrderStatusBadge,
    ViewOrderModal,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  data() {
    let walkingCustomer = false
    if (window.location.href.includes('walking')) walkingCustomer = true
    return {
      id: null,
      avatarText,
      filters: {},
      total: 0,
      meta: {},
      dataLoading: false,
      // Start BS Table
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      form: {},
      showUpdateModal: false,
      modelLoading: false,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      // End BS Table
      pageLength: 20,
      dir: false,
      fields: [
        {
          key: 'waybill_number',
          label: 'Waybill Number',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'merchant_business',
          label: 'Merchant Business',
          sortable: true,
        },
        {
          key: 'customer_name',
          label: 'Customer Name',
          sortable: true,
        },
        {
          key: 'customer_email',
          label: 'Customer Contact',
          sortable: false,
        },
        {
          key: 'cod',
          label: 'COD',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'collected_cod',
          label: walkingCustomer ? 'Advance' : 'Collected COD',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'delivery_charge',
          label: 'Delivery Charge',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'balance',
          label: 'Balance',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'weight',
          label: 'weight',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
        },
        {
          key: 'status.key',
          label: 'Status',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      rows: [],
      searchTerm: '',
      walkingCustomer,
      json_fields: {
        'Waybill Number': 'waybill_number',
        'Merchant Business': {
          field: 'merchant_business',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        COD: 'cod',
        'Collected COD': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
        Weight: 'weight',
        Description: {
          field: 'description',
          callback: value => `"${value || '--'}"`,
        },
        Status: 'status.name',
      },
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchWaybillForMerchant()
      },
    },
    deep: true,
    page() {
      this.fetchWaybillForMerchant()
    },
    perPage() {
      this.fetchWaybillForMerchant()
    },
  },
  mounted() {
    if (this.walkingCustomer) {
      this.fields = this.fields.filter(f => f.key !== 'merchant_business' && f.key !== 'cod')
      const index = this.fields.findIndex(object => object.key === 'collected_cod')
      const temp = this.fields[index]
      this.fields[index] = this.fields[index + 1]
      this.fields[index + 1] = temp
    } else {
      this.fields = this.fields.filter(f => f.key !== 'balance')
    }
  },
  created() {
    this.id = this.$route.params.id
  },
  methods: {
    async fetchWaybillForMerchant() {
      this.dataLoading = true
      this.rows = []
      try {
        const { data } = (await FinanceRepository.getAllMechantOrdersList(this.page, this.perPage, this.id, this.filterQuery))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchWaybillForMerchantNoPagination() {
      try {
        const { data } = (await FinanceRepository.getAllMechantOrdersListNoPagination(this.id))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    resetModal() {
      this.clearOnClick()
    },
    filterQueryUpdate() {
      this.fetchWaybillForMerchant()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchWaybillForMerchant()
    },
    changePage(value) {
      this.perPage = value
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onClickViewOrder(id) {
      this.$refs.viewOrderModal.openModal(id)
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select.scss';
@media (max-width: 767px) {
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
